import React from 'react';
import { Ambient } from '../Ambient';
import { VexuLockup, ZainMark } from '../Brand';
import { Eyebrow, Hairline, Reveal } from '../Reveal';
const OPPORTUNITIES = [{
  title: 'New AI Revenue Streams',
  body: 'Launch premium AI-powered services for consumer and business subscribers.'
}, {
  title: 'Leverage Existing Telecom Assets',
  body: 'Transform phone numbers, voice connectivity, distribution channels, and subscriber relationships into AI-enabled services.'
}, {
  title: 'Faster Time to Market',
  body: 'Deploy proven AI products without having to build the entire conversational AI technology stack internally.'
}, {
  title: 'Multiple Verticals. One Partnership.',
  body: 'Consumer AI, business communications, and conversational commerce — powered by one underlying technology platform.'
}];
export function PartnershipSlide() {
  return <section className="relative h-full w-full" data-id="element-634" data-mp="1j3amqiu7evjt">
      <Ambient variant="default" data-id="element-635" data-mp="1j1zmuu3vq7xz" />

      <div className="relative flex h-full gap-[70px] px-[100px] pb-[70px] pt-[76px]" data-id="element-636" data-mp="41ude5bsbm3u">
        {/* Narrative */}
        <div className="flex w-[520px] flex-col" data-id="element-637" data-mp="3v7vi7w55pjh1">
          <Reveal delay={0} data-id="element-638" data-mp="3v96rucla9lg2">
            <Eyebrow data-id="element-639" data-mp="3qhf2g5dv5lri">Why Vexu × Zain</Eyebrow>
          </Reveal>

          <Reveal delay={0.08} y={18} data-id="element-640" data-mp="3qfu9ulb40cwa">
            <div className="mt-[26px] flex items-center gap-[24px]" data-id="element-641" data-mp="3livc7ss8lntc">
              <VexuLockup size={38} wordmarkSize={30} data-id="element-642" data-mp="3lghipod7gjnw" />
              <span className="text-[26px] text-slate-300" data-id="element-643" data-mp="3gkk35k9rnhc6">×</span>
              <ZainMark height={34} data-id="element-644" data-mp="3ci5mn6tkkto2" />
            </div>
          </Reveal>

          <Reveal delay={0.16} data-id="element-645" data-mp="3ck05mfla6bpi">
            <h2 className="mt-[30px] text-[38px] font-light leading-[1.24] tracking-[-0.025em] text-slate-500" data-id="element-646" data-mp="37iaukzy25y1f">
              Turning Telecom Infrastructure &amp; Reach into{' '}
              <span className="font-medium text-slate-900" data-id="element-647" data-mp="15rfw20cgvkr0">
                AI-Powered Services
              </span>
            </h2>
          </Reveal>

          <div className="flex-1" data-id="element-648" data-mp="10to5parh06ox" />

          <Reveal delay={0.5} data-id="element-649" data-mp="10qjw1xv8kiqv">
            <Hairline data-id="element-650" data-mp="2v81p23o9blax" />
            <p className="pt-[28px] text-[19px] font-light leading-[1.6] tracking-[-0.01em] text-slate-500" data-id="element-651" data-mp="2v7tckcw1qi09">
              Zain brings the network, reach and customer relationship. Vexu
              brings the AI technology.
              <br data-id="element-652" data-mp="2l8atrzrvh29s" />
              <span className="font-medium text-slate-900" data-id="element-653" data-mp="2q9i1jyu0m1gg">
                Together, we can create the next generation of telecom services.
              </span>
            </p>
          </Reveal>

          <Reveal delay={0.58} data-id="element-654" data-mp="3dx88xu0seiyb">
            <div className="mt-[30px] flex items-center gap-[18px]" data-id="element-655" data-mp="3iyfjg0ubdw8o">
              <ZainMark height={22} data-id="element-656" data-mp="340wyzaoo6571" />
              <span className="text-[15px] text-slate-300" data-id="element-657" data-mp="33zvaa3eqdk6u">+</span>
              <VexuLockup size={24} wordmarkSize={16} data-id="element-658" data-mp="38zq0e4qom5qu" />
              <span className="text-[15px] text-vexu-600" data-id="element-659" data-mp="38yexe752920s">→</span>
              <span className="text-[13px] font-semibold uppercase tracking-[0.2em] text-vexu-600" data-id="element-660" data-mp="1slgmk4k2fze9">
                Next Generation AI Services
              </span>
            </div>
          </Reveal>
        </div>

        {/* Opportunities */}
        <div className="grid flex-1 grid-cols-2 grid-rows-2 gap-x-[52px] gap-y-[46px] pt-[10px]" data-id="element-661" data-mp="fld850u5jq7v">
          {OPPORTUNITIES.map((item, index) => <Reveal key={item.title} delay={0.22 + index * 0.07} data-id="element-662" data-mp="ooe7mioiij2k" data-mpi={index}>
              <div className="flex h-full flex-col border-t border-slate-900/[0.10] pt-[22px]" data-id="element-663" data-mp="oljqb00spedd">
                <span className="text-[11px] font-semibold tabular-nums tracking-[0.28em] text-vexu-600" data-id="element-664" data-mp="kkgcej2b5ses">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-[14px] text-[23px] font-medium leading-[1.24] tracking-[-0.02em] text-slate-900" data-id="element-665" data-mp="3o0wtzeshu6cw">
                  {item.title}
                </h3>
                <p className="mt-[12px] text-[14.5px] font-light leading-[1.7] text-slate-500" data-id="element-666" data-mp="x8tc7y7zyud">
                  {item.body}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}